


















import Vue from 'vue'
import CSpeechToTextMixin from '~/components/shared/configurable/mixin/CSpeechToTextMixin.vue'
import { RecordingStatus } from '~/constants/speech-recognition'
export default Vue.extend({
  mixins: [CSpeechToTextMixin],
  computed: {
    btnClass() {
      if (this.status === RecordingStatus.IDLE) {
        return 'btn-grey-50'
      } else if (this.status === RecordingStatus.RECORDING) {
        return 'btn-recording'
      }
      return 'btn-danger'
    }
  },
  watch: {
    status(val) {
      this.$emit('recordingStatus', val === RecordingStatus.RECORDING)
    }
  }
})
